import { MenuItem } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import { withStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import { debounce } from "lodash";
import React, { useEffect, useState } from "react";
import { TextValidator } from "react-material-ui-form-validator";

const styles = (theme) => ({
  dropdown: {
    height: "200px",
    overflow: "auto",
    padding: 0,
    marginTop: "5px",
    display: "block",
    minWidth: "100%",
    zIndex: 2,
    backgroundColor: "#f9f9f9",
    position: "absolute",
    boxShadow: "3px 3px 5px 0px rgba(0,0,0,0.19)",
  },
  input: {
    minWidth: "100%",
  },
  active: {
    backgroundColor: "rgba(0,0,0,0.2)",
  },
  ghost: {
    backgroundColor: "rgba(0,0,0,0.1)",
  },
});

function getPosition(id = null, array = []) {
  let position = null;
  for (let i = 0; i < array.length; i++) {
    if (id + "" === array[i].id + "") {
      position = i;
    }
  }
  return position;
}

// function getRandomId() {
//     return Math.random().toString(36).substring(2, 4) + Math.random().toString(36).substring(2, 4);
//
// }

const Select = React.memo(function Select({
  id,
  classes,
  data,
  label,
  value,
  onSearch,
  onChange,
  required,
  loading,
  onClear,
  className,
  name,
}) {
  const onChangeSearch = debounce(onSearch, 550);
  const [text, setText] = useState("");
  const [item, setItem] = useState(null);
  const [isShow, setShow] = useState(false);
  const [position, setPosition] = useState(null);
  const [isFocus, setFocus] = useState(false);
  const [isMouseOver, setMouseOver] = useState(false);

  useEffect(() => {
    const initItem =
      data &&
      data !== null &&
      data !== undefined &&
      data !== "undefined" &&
      Array.isArray(data) &&
      data.length > 0 &&
      value &&
      value !== undefined &&
      value !== "undefined"
        ? data.find((val) => val.id === value)
        : null;

    setItem(initItem);
  }, [value]);

  useEffect(() => {
    function eventListen(event) {
      let element = document.getElementById("ghost");
      // handle up
      if (event.keyCode === 38 && position >= 0) {
        if (position === 0) {
          setPosition(0);
        } else {
          setPosition((prevPos) => prevPos - 1);
        }
        if (element) {
          element.parentNode.scrollTop = element.offsetTop - 50;
        }
      }
      // handle down
      if (event.keyCode === 40 && position <= data.length - 1) {
        if (position === data.length - 1) {
          setPosition(data.length - 1);
        } else {
          setPosition((prevPos) => prevPos + 1);
        }
        if (element) {
          element.parentNode.scrollTop = element.offsetTop + 40;
        }
      }
      // enter item
      if (event.keyCode === 13 && isFocus && data && data.length > 0) {
        const enterItem = data.find((obj, index) => index === position);
        setItem(enterItem);
        onChange(enterItem);
      }
    }
    window.addEventListener("keydown", eventListen);
    return () => window.removeEventListener("keydown", eventListen);
  }, [position, data]);

  useEffect(() => {
    if (text.length > 0) {
      setShow(true);
    }
    if (data && data.length > 0 && text.length === 0 && isFocus) {
      setItem(null);
    }
  }, [text]);
  useEffect(() => {
    setShow(false);
    if (item) setPosition(getPosition(item.id, data));
  }, [item]);
  useEffect(() => {
    if (data && data.length > 0 && item === null) {
      setPosition(0);
    }
  }, [loading]);

  return (
    <div
      style={{ position: "relative", minWidth: "100%" }}
      className={className}>
      <TextValidator
        id={`select-auto-complete${id ? id : label}`}
        label={label}
        name={name ? name : "select-auto-complete"}
        variant="outlined"
        value={item ? item.label : text}
        validators={required ? ["required"] : []}
        required={required}
        autoComplete="off"
        errorMessages={[`Không được để trống`]}
        onClick={() => setShow(true)}
        onFocus={(e) => {
          e.preventDefault();
          setFocus(true);
          setText(text ? text : "");
          onChangeSearch(text ? text : "");

          if (data && item && data.length > 0) {
            setPosition(getPosition(item.id, data));
          } else {
            setPosition(0);
          }
        }}
        onBlur={(e) => {
          e.preventDefault();
          setFocus(false);
          setPosition(null);
          setText("");
          if (!isMouseOver) {
            setShow(false);
          }
        }}
        className={classes.input}
        onChange={(e) => {
          e.preventDefault();
          const value = e.target.value ? e.target.value : "";
          setText(value);
          onChangeSearch(value);
          setItem(null);
        }}
        InputProps={{
          endAdornment: loading ? (
            <CircularProgress
              style={{ display: "inline-flex", height: 25, width: 25 }}
            />
          ) : onClear && item ? (
            <CloseIcon
              style={{ cursor: "pointer" }}
              onClick={() => {
                onChange(null);
                setItem(null);
                setText("");
              }}
            />
          ) : (
            ""
          ),
        }}
      />
      {data && data.length > 0 && isShow && (
        <div
          className={classes.dropdown}
          onMouseOver={() => {
            setMouseOver(true);
          }}
          onMouseOut={() => {
            setMouseOver(false);
          }}
          onScroll={() => {
            const overMouse = document.getElementById(
              `select-auto-complete${id ? id : label}`
            );
            overMouse.focus();
          }}>
          {data.map((val, index) => {
            return (
              <MenuItem
                id={position === index ? "ghost" : ""}
                className={
                  item && item.id === val.id
                    ? classes.active
                    : position === index
                    ? classes.ghost
                    : ""
                }
                key={index}
                value={val.id}
                onClick={() => {
                  setItem(val);
                  onChange(val);
                  setMouseOver(false);
                  // setShow(false);
                }}>
                {val.label}
              </MenuItem>
            );
          })}
        </div>
      )}
    </div>
  );
});

export default withStyles(styles)(Select);
